module.exports = __webpack_public_path__ + "img/op_img-carrusel-personas.81c7051.jpg";